import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import { Button, DialogContent, Divider } from '@mui/material';
import AppSimpleDialog from 'app/shared-components/dialogs/AppSimpleDialog';
import { ModalComponent } from 'app/shared-components/modals/modalManager';
import { useState } from 'react';
import { getOfferSignUrls } from 'src/app/api/OffersApi';

export const OfferCompletedMessageDialog: ModalComponent<{ offerId: number }> = ({
  open,
  onClose,
  props,
}) => {
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [loading, setLoading] = useState(false);

  const handleContinue = async () => {
    setLoading(true);
    try {
      const res = await getOfferSignUrls(props.offerId);
      if (res) {
        window.open(res.data.data.signUrl, '_blank');
        setLoading(false);
      }
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <AppSimpleDialog
      open={open}
      handleClose={onClose}
      title="Processor requires additional information"
      size="sm"
      scroll="paper"
      disableScrollLock
      fullScreen={isMobile}
    >
      <Divider />
      <DialogContent className="px-24 flex flex-col">
        <p className="mb-24">
          Thank you for completing this application! Currently, we are preparing a pre-application
          for you that will help you confirm a deal with the selected payment processor. You will be
          redirected to ZohoSign. There please review all of the data that we have collected, if
          everything is correct please sign the pre-application. The signed pre-application will be
          sent to you and the selected processor.
        </p>
        <Button
          className="rounded-full bg-blue-primary px-14 hover:bg-blue-primary-hover text-white"
          type="submit"
          size="large"
          onClick={handleContinue}
          disabled={loading}
        >
          {loading ? 'loading...' : 'Continue'}
        </Button>
      </DialogContent>
    </AppSimpleDialog>
  );
};
